import React, { MouseEvent } from 'react';
import clsx from 'clsx';
import { Box, makeStyles } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Typography from '#web-components/components/Typography';
import styles from './ServiceCard.styles';

export type ServiceCardProps = {
  children: React.ReactNode,
  disabled?: boolean,
  variant: 'default' | 'compact',
  className?: string,
  onClick: () => void,
  actions?: React.ReactNode,
  'data-xpath'?: string;
};

const useStyles = makeStyles(styles, { name: 'ServiceCard' });

const ACTIONS_CARD = 'service-card-actions';
const DIALOG = 'MuiDialog-container';

export default function ServiceCard({
  children,
  disabled,
  variant = 'default',
  className,
  onClick,
  actions,
  'data-xpath': dataXpath,
}: ServiceCardProps) {
  const classes = useStyles({ disabled, variant });
  const onClickHandler = (event: MouseEvent) => {
    let currentElement = event.target as Element;

    while (currentElement.parentNode) {
      const classList = Array.from(currentElement?.classList);
      if (classList.includes(ACTIONS_CARD) || classList.includes(DIALOG)) {
        return false;
      }
      currentElement = currentElement.parentNode as Element;
    }
    return onClick();
  };

  return (
    <Box className={clsx(classes.root, className)} onClick={onClickHandler}>
      <Box className={classes.icon}>
        <Typography variant="h4">{variant === 'default' ? '📁' : '📝'}</Typography>
      </Box>
      <Typography
        variant={variant === 'default' ? 'accentXL' : 'accentRegular'}
        className={classes.name}
        data-xpath={dataXpath}
      >
        {children}
      </Typography>
      {
        actions
          ? <Box className={clsx([classes.actions, ACTIONS_CARD])}>{actions}</Box>
          : (
            <ArrowForwardIcon
              width={36}
              height={36}
              className={clsx(classes.actions, classes.endIcon, 'serviceCardArrowForward')}
            />
          )
      }
    </Box>
  );
}
